/*
  CFG - Free Shipping Bar Logic
  Calculates and displays progress towards free shipping.
*/

(function () {
  'use strict';

  const selectors = {
    bar: '#FreeShippingBar',
    message: '.free-shipping-bar__message',
    progress: '.free-shipping-bar__progress',
    drawerSubtotal: '[data-subtotal]'
  };

  function init() {
    const bar = document.querySelector(selectors.bar);
    if (!bar) return;

    const threshold = parseInt(bar.dataset.threshold, 10);
    if (isNaN(threshold)) return;

    updateBar(bar, threshold);

    // Listen for cart updates
    // 1. Ajax Product Added (from theme.js)
    document.addEventListener('ajaxProduct:added', () => {
      // Small delay to allow cart to update
      setTimeout(() => updateBar(bar, threshold), 500);
    });

    // 2. Observe Subtotal changes (for qty updates within drawer)
    const subtotalEl = document.querySelector(selectors.drawerSubtotal);
    if (subtotalEl) {
      const observer = new MutationObserver(() => {
        updateBar(bar, threshold);
      });
      observer.observe(subtotalEl, { childList: true, subtree: true, characterData: true });
    }

    // 3. Listen for drawer open (in case it wasn't updated recently)
    // theme.js uses 'cart:open' event sometimes, or we can listen to click
    document.addEventListener('cart:open', () => {
      updateBar(bar, threshold);
    });
  }

  function updateBar(bar, threshold) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const total = cart.total_price;
        const progress = Math.min((total / threshold) * 100, 100);
        const remaining = threshold - total;

        const messageEl = bar.querySelector(selectors.message);
        const progressEl = bar.querySelector(selectors.progress);

        if (progressEl) {
          progressEl.style.width = `${progress}%`;
        }

        if (messageEl) {
          if (remaining > 0) {
            // Format money (basic implementation, can use theme.Currency if available)
            let remainingFormatted = theme.Currency ? theme.Currency.formatMoney(remaining, theme.settings.moneyFormat) : '$' + (remaining / 100).toFixed(2);

            // CFG: User request to remove .00 if present
            remainingFormatted = remainingFormatted.replace('.00', '');

            messageEl.innerHTML = `You are ${remainingFormatted} away from free shipping (USA)!`;
          } else {
            messageEl.innerHTML = `You've got free shipping (USA)!`;
          }
        }
      })
      .catch(error => console.error('Error fetching cart:', error));
  }

  // Init when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
